export default function AdvancedServiceMsg({ serviceToShow, t, handleSubmit, onSubmit, i18n }) {
    return (
        <div id={`AdvanceServiceMsg`}
            className="modal fade bg-transparent col-12 col-md-7 mt-5"
            tabIndex="-1"
            aria-hidden="true"
            aria-labelledby="advanceServiceMsglsLabel"
            data-bs-backdrop="static" data-bs-keyboard="false">

            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="advanceServiceMsglsLabel">{t("GetQoutation")}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form className="p-4">
                            <div className="mb-3 row align-items-center">
                                <label className="col-4 col-form-label">{t("ServiceName")}</label>
                                <div className="col-8">
                                    <input
                                        type="text"
                                        className="form-control text-center"
                                        value={i18n.language = "ar" ? serviceToShow.nameAr : serviceToShow.name}
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="mb-3 row align-items-center">
                                <label className="col-4 col-form-label">{t("Phone")}</label>
                                <div className="col-8">
                                    <input
                                        type="text"
                                        className="form-control text-center"
                                        placeholder="05xxxxxxxx"
                                    />
                                </div>
                            </div>
                            <div className="mb-3 row align-items-start">
                                <label className="col-4 col-form-label">{t("Details")}</label>
                                <div className="col-8">
                                    <textarea
                                        className="form-control"
                                        rows={5}
                                        placeholder={t("Add Details")}
                                    ></textarea>
                                </div>
                            </div>
                            <div className="text-start">
                                <button type="submit" className="float-end btn-masar btn-dark-orange"
                                    onSubmit={handleSubmit(onSubmit)}>{t("Send")}</button>
                            </div>
                        </form>

                    </div>

                </div>
            </div>
        </div>

    )
}